import { render } from "./WithdrawalView.vue?vue&type=template&id=61464abf&scoped=true"
import script from "./WithdrawalView.vue?vue&type=script&lang=js"
export * from "./WithdrawalView.vue?vue&type=script&lang=js"

import "./WithdrawalView.vue?vue&type=style&index=0&id=61464abf&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61464abf"]])

export default __exports__